import TemplateView from '../../../../../js/TemplateView'
import ExportCSVButton from '../../../../../js/components/ExportCSVButton'
import {getLocalStorage} from '../../../../../js/util/LocalStorage'

const EXPORT_ON_RELOAD_FLAG = "runCSVExportOnReload"

class LeaveRequestsExportToCSVPanel extends TemplateView {

    constructor({onExportButtonClick = () => {}}) {
        super()
        this.state = {
            disabled: false,
            inProgress: false
        }
        this.callbacks = {
            onExportButtonClick
        }
        this.onStatePropertyChanged("disabled", disabled => {
            this.exportButton.setState({disabled})
        })
        this.onStatePropertyChanged("inProgress", inProgress => {
            this.exportButton.setState({inProgress})
        })
    }


    templateHtml() {
        return "<div class='leaveRequestExportPanel csvExportPanel'>" +
               "    <div class='csvExport container'/>" +
               "    <div class='separator'/>" +
               "</div>"
    }

    onError(e) {
        console.error(e)
        if (e.isInstanceOfEntityNotFound) {
            // we need to reload page AND perform export right after load. so store temporary flag
            // which expires in 1 minute (reload must not take such long)
            getLocalStorage().setItem(EXPORT_ON_RELOAD_FLAG, new Date().getTime() + 60000)
            document.location.reload()
        } else {
            throw e
        }

    }

    afterRender() {
        this.exportButton = new ExportCSVButton({
            labelMessageKey: "actiplans.corporate_requests.buttons.export_to_csv",
            noDataMessageKey: "actiplans.leave_time_requests.csv.no_data",
            exportAction: () => {
                this.callbacks.onExportButtonClick()
            }
        }).init(this.find(".csvExport"))

        const reloadBefore = getLocalStorage().getItem(EXPORT_ON_RELOAD_FLAG)
        getLocalStorage().removeItem(EXPORT_ON_RELOAD_FLAG)
        if (reloadBefore && reloadBefore > new Date().getTime()) {
            setTimeout(() => this.callbacks.onExportButtonClick())
        }
    }
}

export default LeaveRequestsExportToCSVPanel


// WEBPACK FOOTER //
// ./web/actiplans/js/administration/corporateRequests/exportToCsv/LeaveRequestsExportToCSVPanel.js